import React from 'react';

import {hashedClasses, withCssModule} from '@pb/kit-util-with-css-module';

import styles from './page.component.module.styl';

import type {ComponentProps, FC} from 'react';


const classNames = withCssModule(styles);
const classes = hashedClasses(styles);

type Props = {
    /**
     * Copyright notice text rendered in a dedicated `<div>` at the top of the
     * footer. When omitted, no copyright element is rendered.
     */
    copyright?: string,
} & ComponentProps<'footer'>;

/**
 * Bottom `<footer>` bar of a `<Page>` layout.
 *
 * Renders a semantic `<footer>` element with the `page__footer` and `footer`
 * layout classes. Optionally shows a `copyright` string above the links region.
 * Remaining `children` are rendered inside the footer links area.
 */
export const PageFooter: FC<Props> = props => {
    const {
        copyright,
        children,
        className,
        ...footerProps
    } = props;

    return (
        <footer {...footerProps} className={classNames('page__footer footer', className)}>
            {copyright ? <div className={classes.footer__copyright}>{copyright}</div> : null}
            <div className={classes.footer__links}>{children}</div>
        </footer>
    );
};

PageFooter.displayName = 'PageFooter';
